/* eslint-disable
    import/no-unresolved,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
require('./statementCard.scss');

const deps = [
  require('data/collection/balanceChecker').name,
  require('data/collection/document').name,
  require('data/collection/ledger').name,
  require('data/date').name,
  require('ui/web/table').name,
  require('ui/web/form').name,
  require('ui/web/bcStatusIcon').name,
  require('ui/web/statusSelector').name,
  require('ui/common/radio').name,
  require('ui/web/popoverMenu').name,
  require('ui/web/documentPreview').name,
];

module.exports = angular
  .module('bench.ui.statementCard', deps)

  .directive('blStatementCard', () => ({
    restrict: 'E',
    scope: {
      clientId: '=',
      ledgerId: '=',
      date: '=',
    },
    bindToController: true,
    template: require('./statementCard.html'),
    controller: require('./statementCardCtrl.js'),
    controllerAs: 'vm',
  }));
